module.exports = __webpack_public_path__ + "images/emoji/tongue.226fd1c29cd5636e8fd6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tongue.png
// module id = jmUv
// module chunks = 14